import { Container } from '@material-ui/core';
import Page from '../../components/Page';

export default function ConfigApis() {
  return (
    <Page title="Dashboard: Api's | ZIMTA">
      <Container>
        <div> Config Api's Page</div>
      </Container>
    </Page>
  );
}
